<div class="filters-container" role="radiogroup" aria-label="Conversation filters">
  @for (filter of filters; track filter.value) {
    <button
      type="button"
      role="radio"
      class="filter-chip"
      [attr.data-cy]="'Chat:conversationFilter:' + filter.value"
      [class.active]="activeFilter() === filter.value"
      [attr.aria-checked]="activeFilter() === filter.value"
      (click)="selectFilter(filter.value)"
    >
      {{ filter.label }}
    </button>
  }
</div>
